import { BrowserRouter, Outlet, Route, Routes } from "react-router-dom";

import { Container } from "reactstrap";
import Header from "./Header";
import Footer from "./Footer";

import Middlepart from "./Middlepart";
import Sidebar from "./Sidebar";
import Alert from 'react-bootstrap/Alert';
import Toast from 'react-bootstrap/Toast';
import { useState, useEffect, useContext } from "react";
import { AlertContext, NotificationContext, HospitalContext, RoleContext } from "../utils/contexts/RoleContext";
import { useNavigate } from "react-router-dom";


// import MiddlePart from "./Middlepart";


const FullLayout = ({ children }: any) => {
  // const [show, setShow] = useState(false);
  // const [message, setMessage] = useState("");
  const [notificationCount, setNotificationCount] = useState<any>(0);
  const [notifications, setNotifications] = useState<any>([]);
  // const [successValue, setSuccessValue] = useState("");
  const [myProfile, setMyProfile] = useState<any>({});
  const [searchOn, setSearchOn] = useState(false);
  const [hospitals, setHospitals] = useState([]);
  const [selectedHospital, setSelectedHospital] = useState<any>();

  const navigate = useNavigate();
  const currentUser = useContext(RoleContext);
  const toast: any = useContext(AlertContext);

  const {show, successValue, message} = toast;

  return (
    <main>
      <div className="pageWrapper d-lg-flex">
        {/********Sidebar**********/}
        <aside className="sidebarArea iboost-box-shadow" id="sidebarArea">
          <Sidebar />
        </aside>
        {/********Content Area**********/}
        <div className="contentArea">
          {/********header**********/}
          <Header />
          {show &&

            <Toast className={successValue === "success" ? "float-start end-0 position-absolute show bg-success z-3" : "float-start end-0 position-absolute show bg-danger z-3"}>
              {/* <Toast.Header className={`show ${successValue === "success" ? "bg-success" : "bg-danger"}`}>

                <strong className="me-auto text-white">Success Message</strong>

              </Toast.Header> */}
              <div aria-live="polite" aria-atomic="true" className="d-flex justify-content-center align-items-center w-100 mb-10 text-white bg-transparent">
                <div className="fade toast show  bg-transparent" role="alert" aria-live="assertive" aria-atomic="true">
                  <div className="fade toast show bg-transparent p-4 text-white">
                    {message}
                    {/* test mesasge */}
                  </div>
                </div>
              </div>
            </Toast>
          }


          {/********Middle Content**********/}
          <Container className={`p-4 wrapper ${searchOn && "mt-3"}`} fluid>
            {/* <Middlepart /> */}
            {children}
          </Container>

        </div>

      </div>
      <Footer/>
    </main>
  );
};

export default FullLayout;